module.exports = __webpack_public_path__ + "img/BackhoeLoader.8e832772.png";